import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaBars, FaTimes } from 'react-icons/fa';
import '../styles/Navbar.css';

const Navbar = ({ onPaymentClick }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Inicio', href: '#hero' },
    { name: 'Problema', href: '#problem' },
    { name: 'Solución', href: '#comparison' },
    { name: 'Beneficios', href: '#benefits' },
    { name: 'FAQ', href: '#faq' },
  ];

  const handleScroll = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false);
    }
  };

  return (
    <motion.nav
      className={`navbar ${isScrolled ? 'scrolled' : ''}`}
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="navbar-container">
        {/* Logo */}
        <motion.div
          className="navbar-logo"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => handleScroll('#hero')}
        >
          <img src="/logo_negro.png" alt="EMI Logo" className="logo-image" />
        </motion.div>

        {/* Desktop Navigation */}
        <ul className="nav-menu">
          {navLinks.map((link, index) => (
            <motion.li
              key={index}
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              <button
                className="nav-link"
                onClick={() => handleScroll(link.href)}
              >
                {link.name}
              </button>
            </motion.li>
          ))}
        </ul>

        {/* CTA Button */}
        <motion.button
          className="cta-button primary navbar-cta"
          onClick={onPaymentClick}
          whileHover={{ scale: 1.05, boxShadow: '0 15px 40px rgba(255, 100, 0, 0.4)' }}
          whileTap={{ scale: 0.95 }}
        >
          Acceso por $99
        </motion.button>

        {/* Mobile Menu Button */}
        <button
          className="hamburger"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle menu"
        >
          {isOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {/* Mobile Navigation */}
      <motion.div
        className={`mobile-menu ${isOpen ? 'open' : ''}`}
        initial={{ opacity: 0, height: 0 }}
        animate={{ opacity: isOpen ? 1 : 0, height: isOpen ? 'auto' : 0 }}
        transition={{ duration: 0.3 }}
      >
        <ul className="mobile-nav-menu">
          {navLinks.map((link, index) => (
            <li key={index}>
              <button
                className="mobile-nav-link"
                onClick={() => handleScroll(link.href)}
              >
                {link.name}
              </button>
            </li>
          ))}
          <li>
            <motion.button
              className="cta-button primary mobile-cta"
              onClick={onPaymentClick}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              Acceso por $99
            </motion.button>
          </li>
        </ul>
      </motion.div>
    </motion.nav>
  );
};

export default Navbar;
